import { Market } from '../../generated/graphql';
import compact from 'lodash/compact';

export const marketToString = (market: Market) => {
  if (!market) {
    return '';
  }

  const country = (market?.country || '') === 'US' ? '' : market?.country;

  return compact([market?.city, market?.state, country]).join(', ');
};
